
import Button from 'primevue/button'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UsersListPage',
  components: { Button },
  props: {
    config: {
      type: Object,
      required: true,
    },
    listComponent: {
      type: [Object, Function],
      required: true,
    },
  },
})
